import { render, staticRenderFns } from "./ProductSimpleCmp.vue?vue&type=template&id=09bb5ba4&scoped=true&"
import script from "./ProductSimpleCmp.vue?vue&type=script&lang=js&"
export * from "./ProductSimpleCmp.vue?vue&type=script&lang=js&"
import style0 from "./ProductSimpleCmp.vue?vue&type=style&index=0&id=09bb5ba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bb5ba4",
  null
  
)

export default component.exports